import constants from './constants'

export default {
    convertPosIdToStr: function(posId) {
        return constants.positionIDStringMap[posId] || 'N/A';
    },
    getAge: function(birthdate) {
        if (!birthdate) return null;
        return ((Date.now() - new Date(birthdate)) / 31557600000).toFixed(1);
    },
};